/**
 * Punto de entrada de la app **Cliente** de la marca **Nitrofert** (producto
 * Nitria). Al cargar el DOM arranca `ClienteInit` con la configuración de la
 * marca (`fx_createNitrofertInitData`), que incluye la entrada por el portal de
 * Nitria: sin sesión válida la app redirige al portal, no muestra login propio.
 */
import { ClienteInit } from "../cliente/ClienteInit";
import { fx_createNitrofertInitData } from "./nitrofertInitData";

document.addEventListener("DOMContentLoaded", () => {
  new ClienteInit(fx_createNitrofertInitData()).init();
});
